import { Fragment, ReactNode } from 'react';

import { getEmojiImageUrl, getEmojiRegex } from '../lib/util/emoji';

type EmojiTextProps = {
  text: string;
};

export const renderEmojiText = (text: string): ReactNode => {
  const content: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of Array.from(text.matchAll(getEmojiRegex()))) {
    const emoji = match[0];
    const index = match.index ?? 0;

    if (index > lastIndex) {
      content.push(text.slice(lastIndex, index));
    }

    content.push(<EmojiImage key={`${emoji}-${index}`} src={getEmojiImageUrl(emoji)} alt={emoji} />);
    lastIndex = index + emoji.length;
  }

  if (lastIndex < text.length) {
    content.push(text.slice(lastIndex));
  }

  return content.length ? <Fragment>{content}</Fragment> : text;
};

export const EmojiText = ({ text }: EmojiTextProps) => <>{renderEmojiText(text)}</>;

const EmojiImage = ({ alt, src }: { alt: string; src: string }) => (
  <img className="twemoji" src={src} alt={alt} loading="lazy" draggable={false} />
);
